import { forwardRef, useContext, memo } from 'react';
import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack } from '@cbhq/cds-web/layout';
import { TextHeadline, TextBody } from '@cbhq/cds-web/typography';
import getCoinbaseLocalizedUrl from '../../../../utils/getCoinbaseLocalizedUrl.js';
import '../../../Link/index.js';
import GlobalNavContext from '../../context/GlobalNavContext.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Link from '../../../Link/Link.js';
const TrapdoorDescriptionColumn = /*#__PURE__*/forwardRef(({
  title,
  description,
  linkText,
  url,
  image
}, ref) => {
  const _useContext = useContext(GlobalNavContext),
    localeCode = _useContext.localeCode;
  return /*#__PURE__*/jsxs(DescriptionColumn, {
    ref: ref,
    children: [/*#__PURE__*/jsx(StyledImage, {
      src: image
    }), /*#__PURE__*/jsxs(VStack, {
      children: [/*#__PURE__*/jsx(TextHeadline, {
        as: "p",
        children: title
      }), /*#__PURE__*/jsx(TextBody, {
        as: "p",
        color: "foregroundMuted",
        children: description
      })]
    }), linkText && url && /*#__PURE__*/jsxs(StyledLink, {
      logEvents: true,
      to: getCoinbaseLocalizedUrl(url, localeCode),
      title: linkText,
      children: [/*#__PURE__*/jsx(HeadlineLinkText, {
        children: linkText
      }), /*#__PURE__*/jsx(Icon, {
        name: "caretRight",
        size: "xs"
      })]
    })]
  });
});
const TrapdoorDescriptionColumn$1 = /*#__PURE__*/memo(TrapdoorDescriptionColumn);
const DescriptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 327px;
  gap: 12px;
`;
const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;
const HeadlineLinkText = styled.span`
  font-weight: 500;
  line-height: 16px;
  color: ${p => p.theme.color.textAccent};
  &:hover {
    color: ${({
  theme
}) => theme.color.textAccentHover};
  }
`;
const StyledImage = styled.img`
  border-radius: 16px;
  height: 156px;
  width: 327px;
  object-fit: cover;
`;
export { TrapdoorDescriptionColumn$1 as default };
//# sourceMappingURL=TrapdoorDescriptionColumn.js.map
